

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Project
import NavBarDown from "~/components/NavBarDown.vue";
import LinkExternal from "~/components/LinkExternal.vue";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component imports -------------------------------------------------------

    components: {
        NavBarDown,
        LinkExternal
    },

    // Component Attribute Properties ------------------------------------------

    props: {
        linkStore: {
            type: String,
            required: false,
            default: "navBar"
        }
    },

    // Component Computed Properties -------------------------------------------

    computed: {
        menuLinks (): [] {
            return this.$store.state[this.linkStore];
        }
    },

    // Methods / Functions  ----------------------------------------------------

    methods: {
        handleClicked (): void {
            this.$emit("navLinkClicked");
        }
    }

    // -------------------------------------------------------------------------
});
